import { Resource } from '@topconagriculture/permissions';

import { ReportFormat } from './reports.types';

export const automatedReportFormats: ReportFormat[] = [
  { id: 0, type: 'pdf', ext: 'pdf' },
  // { id: 1, type: 'vnd.ms-excel', ext: 'xls' },
  { id: 1, type: 'text/csv', ext: 'csv' },
  { id: 2, type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', ext: 'xlsx' },
];

export const reportDownloadFormats: ReportFormat[] = [
  { id: '1', type: 'pdf', ext: 'pdf' },
  // { id: '2', type: 'vnd.ms-excel', ext: 'xls' },
  { id: '2', type: 'text/csv', ext: 'csv' },
  { id: '3', type: 'rtf', ext: 'rtf' },
  { id: '4', type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', ext: 'xlsx' },
];

export enum DownloadEntityType {
  FeedingsList = 'feedingsList',
  FeedingsLoads = 'feedingsLoads',
}

export enum ReportType {
  IngredientsPremixUsage = 'ingredientusage',
  LoadReport = 'loadreport',
  DMIntakePerHead = 'drymatterintake',
  RationDelivery = 'rationdelivery',
  GroupDelivery = 'groupdelivery',
  OperatorAccuracy = 'operatoraccuracy',
  DryMatterEfficiency = 'drymatterefficiency',
  IngredientUsageByPen = 'ingredientusagegroup',
  CattleMovements = 'cattlemovements',
  ClosedLots = 'closedlots',
}

export enum InventoryReportType {
  Inventory = 'inventory',
  InventoryProjectedRequirements = 'inventoryrequirements',
  StockTransaction = 'stocktransaction',
}

export enum DatatoolReportType {
  PenSettingChanges = 'groupchanges',
  RationSettingChanges = 'rationchanges',
  IngredientSettingChanges = 'ingredientchanges',
  IngredientPriceSettingChanges = 'ingredientpricechanges',
  IngredientDryMatterSettingChanges = 'ingredientdrymatterchanges',
  IngredientInventoryChanges = 'inventoryhistory',
}

export enum LotReports {
  CostSummary = 'lotcost',
}

export enum ReportErrorColors {
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
  Default = 'default',
}

export const reportTypeResourceMap = {
  [ReportType.DMIntakePerHead]: Resource.FEED_REPORTS_DRYMATTERINTAKE,
  [ReportType.GroupDelivery]: Resource.FEED_REPORTS_GROUPDELIVERY,
  [ReportType.RationDelivery]: Resource.FEED_REPORTS_RATIONDELIVERY,
  [ReportType.OperatorAccuracy]: Resource.FEED_REPORTS_OPERATORACCURACY,
  [ReportType.LoadReport]: Resource.FEED_REPORTS_LOADREPORT,
  [ReportType.IngredientsPremixUsage]: Resource.FEED_REPORTS_INGREDIENTUSAGE,
  [ReportType.DryMatterEfficiency]: Resource.FEED_REPORTS_DRYMATTEREFFICIENCY,
  [ReportType.IngredientUsageByPen]: Resource.FEED_REPORTS_INGREDIENTUSAGEGROUP,
  [ReportType.CattleMovements]: Resource.FEED_REPORTS_CATTLEMOVEMENTS,
  [ReportType.ClosedLots]: Resource.FEED_REPORTS_CLOSEDLOTS,
  [InventoryReportType.Inventory]: Resource.FEED_REPORTS_INVENTORY,
  [InventoryReportType.InventoryProjectedRequirements]: Resource.FEED_REPORTS_INVENTORY_REQUIREMENTS,
  [InventoryReportType.StockTransaction]: Resource.FEED_REPORTS_INVENTORY_TRANSACTIONS,
  [LotReports.CostSummary]: Resource.FEED_REPORTS_LOTCOSTS,
};
